module.exports = __webpack_public_path__ + "img/pennellata-listing-home.01a7e933.jpg";